module.exports = __webpack_public_path__ + "static/img/beni.4ee6046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/beni.jpg
// module id = b876
// module chunks = 1